module.exports = __webpack_public_path__ + "img/licenciatura.a8a0d123.svg";